<div *ngIf="_appConstant.ShowAdminDashboard == true">
  <app-admin-dashboard></app-admin-dashboard>
</div>
<div *ngIf="_appConstant.ShowAdminDashboard == false">
  <app-user-dashboard></app-user-dashboard>
</div>